import React from 'react'
import { BadgeColor } from './BadgeColor.type'

export type BadgeProps = {
  color: BadgeColor
  children: React.ReactNode
  testId?: string
}

export const Badge = (props: BadgeProps) => {
  const { color, children, testId } = props
  const classNames = []

  switch (color) {
    case BadgeColor.BERRY:
      classNames.push('Badge--berry')
      break
    case BadgeColor.DARK_MINT:
      classNames.push('Badge--dark-mint')
      break
    case BadgeColor.LIME:
      classNames.push('Badge--lime')
      break
  }

  return (
    <span
      className={`Badge ${classNames.join(' ')}`}
      data-testid={testId ? `${testId}` : null}
    >
      {children}
    </span>
  )
}
